






















import { computed, defineComponent } from '@vue/composition-api';
import { Feature, FeatureCollection } from 'geojson';
import { createLayers, locationsClickHandler } from '@/components/map/mapUtils';
import MglMap from '@/components/map/MglMap.vue';
import { ControlTypes } from '@/components/map/mglUtils';
import { Area } from '@/store/types';
import { getMapOptionsForField } from '@/utils/mapFetching';

export default defineComponent({
	props: {
		hasProgress: {
			type: Boolean,
		},
		locations: {
			type: Object as () => FeatureCollection,
		},
		activeLocation: {
			type: Object as () => Feature,
		},
		area: {
			type: Object as () => Area,
		},
		hasInteractiveLocations: {
			type: Boolean,
			default: false,
		},
		hasGeolocateControl: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		MglMap,
	},
	setup(props) {
		const mapOptions =
			props.area || props.locations
				? getMapOptionsForField((props.area as Area) || (props.locations as FeatureCollection))
				: {};

		const layers = computed(() =>
			createLayers({
				areas: [props.area as Area],
				locations: props.locations,
				activeLocation: props.activeLocation,
				polygon: true,
			})
		);

		const progress = computed(() => {
			if (props.locations) {
				const completed = props.locations.features.filter(
					(l: Feature) => l.properties?.markerType !== 'LOCATION_INCOMPLETE'
				).length;
				const total = props.locations.features.length;
				return `${completed} / ${total}`;
			}
		});

		return {
			layers,
			controls: props.hasGeolocateControl ? [ControlTypes.Geolocate] : [],
			eventHandlers: props.hasInteractiveLocations ? [locationsClickHandler] : [],
			progress,
			mapOptions,
		};
	},
});
